import { UpdateBoard, UpdateBoardVariables } from './__generated__/UpdateBoard'

import { gql } from 'apollo-boost'
import { useMutation } from '@apollo/react-hooks'

const MUTATION = gql`
  mutation UpdateBoard($input: UpdateBoardInput!) {
    updateBoard(input: $input) {
      updated
      board {
        id
        title
        quietHoursBegin
        quietHoursEnd
        boardStyle
        timezone {
          id
          timezoneCity
        }
      }
    }
  }
`

export const useUpdateBoard = () => {
  return useMutation<UpdateBoard, UpdateBoardVariables>(MUTATION)
}
